'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
export default function RemoveButton(_ref) {
  let {
    disabled,
    onClick
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["disabled", "onClick"]);

  return /*#__PURE__*/_jsx(UIIconButton, Object.assign({}, rest, {
    disabled: disabled,
    onClick: onClick,
    placement: "right",
    size: "small",
    use: "link",
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: "delete"
    })
  }));
}
RemoveButton.propTypes = {
  ['data-test-id']: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};